import { client } from "../client";
import type { Printer } from "../types/printer.types";

export const fetchPrinters = async () => {
	const response = await client.get<Printer[]>(`printers/`);
	return response.data;
};
